import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { createHigherOrderComponent, useConstrainedTabbing } from '@wordpress/compose';
var withConstrainedTabbing = createHigherOrderComponent(function (WrappedComponent) {
  return function ComponentWithConstrainedTabbing(props) {
    var ref = useConstrainedTabbing();
    return createElement("div", {
      ref: ref,
      tabIndex: "-1"
    }, createElement(WrappedComponent, props));
  };
}, 'withConstrainedTabbing');
export default withConstrainedTabbing;
//# sourceMappingURL=index.js.map